// extracted by mini-css-extract-plugin
export var backdrop = "content-footer-module--backdrop--bc28a";
export var content = "content-footer-module--content--0890b";
export var img = "content-footer-module--img--6efea";
export var link = "content-footer-module--link--433c8";
export var wrapperInner = "content-footer-module--wrapperInner--1be87";
export var wrapperOuter = "content-footer-module--wrapperOuter--138bd primary-footer-module--wrapper--41878";